var _defs, _polygon, _polygon2, _ellipse, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotchflap01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-77,.cls-76{fill:#fff;stroke:#010101;stroke-miterlimit:10;}.cls-77{stroke-width:3.05px;}.cls-76{stroke-width:1.04px;stroke-dasharray:3.12;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "352.04 202.02 352.04 280.1 214.06 317.98 70.96 280.1 70.96 202.02 352.04 202.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "348.83 205.46 348.83 277.13 214.03 314.74 74.17 277.04 74.17 205.46 348.83 205.46"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.57,
    cy: 285.03,
    rx: 16.66,
    ry: 16.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 212.85,
    y: 263.09,
    width: 3.44,
    height: 44.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotchflap01);
export default __webpack_public_path__ + "static/media/NOTCH FLAP-01.98f9f355460acb110829b874402af741.svg";
export { ForwardRef as ReactComponent };